<app-carousel
    [typeSearch]="'Employee'"
></app-carousel>
<div class="body-app mt-3 mb-3">
    <div class="content-app">
        <h5 class="mt-0 mb-2">
            <i class="fa-solid fa-id-card-clip"></i>
            Mi Cuenta
        </h5>
        <div *ngIf="isLoading" class="text-center my-3">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Cargando...</span>
            </div>
            <p class="mt-2">Cargando información...</p>
          </div>
      
          <!-- Sección cuando no se ha encontrado la información del candidato -->
          <div *ngIf="!isLoading && !isFound" class="alert alert-warning text-center" role="alert">
            No se ha encontrado la información de la empresa.
          </div>
      
          <!-- Sección principal cuando se encontró la data -->
          <div *ngIf="!isLoading && isFound">
        <app-register-form-company
        [showSaveButton]="true"
        [showSaveRegister]="false"
        [isEditMode]="true"
        [companyData]="company"
        [companyAddresses]="addresses"
        (savedEmitter)="savedCatcher($event)">
        </app-register-form-company>
          </div>
    </div>
</div>
